// 基础页面（不受权限控制）
import * as COM from '../components';
const baseRouter = [
  /** ------------------------------ 首页 ------------------------------ */
  {path: '/', redirect: '/login'},
  {
    path: '/home',
    redirect: '/home',
    component: COM.HomeLayout,
    name: 'homeLayout',
    meta: { label: '首页' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      {
        path: '/home',
        components: {
          bodyView: COM.Home,
          appHeader: COM.NavHeader,
        },
        name: 'home',
        meta: { label: '首页', icon: 'el-icon-document', menuKeyPath: '/home' },
        children: []
      }
    ]
  },
  /** ------------------------------ 登录页 ------------------------------ */
  { path: '/login',
    redirect: '/login',
    meta: {},
    component: COM.Login,
    name: 'login',
    children: [
      {
        path: '/login',
        name: 'login',
        meta: { label: '登录', icon: 'el-icon-document', menuKeyPath: '/login' },
        children: []
      }
    ]
  },
  // 入口页面
  { path: '/entrance',
    redirect: '/entrance',
    meta: {},
    component: COM.Entrance,
    name: 'entrance',
    children: [
      {
        path: '/entrance',
        name: 'entrance',
        meta: { label: '营销云首页', icon: 'el-icon-document', menuKeyPath: '/login' },
        children: []
      }
    ]
  },
  { path: '/404', component: COM.ErrorPage, meta: {}, name: 'error404' },
  /** ------------------------------ 快速通道 ------------------------------ */
  {
    path: '/fast-channel',
    component: COM.HomeLayout,
    redirect: '/fast-channel',
    name: 'fastChannel',
    meta: { label: '快速通道' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      {
        path: '/fast-channel',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.FastChannel,
          appHeader: COM.NavHeader
        },
        name: 'fastChannelIndex',
        meta: { label: '快速通道', icon: 'el-icon-document', menuKeyPath: '/fast-channel' }
      }
    ]
  },
  // {path: '/', redirect: '/home', component: COM.HomeLayout, name: '权限不足'},
  // 不存在的路由
  { path: '*', redirect: '/home', name: '权限不足', hidden: true }
];
export default baseRouter;
